import { render, staticRenderFns } from "./SelectRegionComponent.vue?vue&type=template&id=06b45f7c"
import script from "./SelectRegionComponent.vue?vue&type=script&lang=js"
export * from "./SelectRegionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports